import cx from 'classnames'
import { type ReactNode } from 'react'

interface LabelProps {
  primary?: boolean
  secondary?: boolean
  isBadge?: boolean
  hasDot?: boolean
  pulsingDot?: boolean
  className?: string
  children: ReactNode
}

const Label = ({
  primary = false,
  secondary = false,
  isBadge = false,
  hasDot = false,
  pulsingDot = false,
  className,
  children,
}: LabelProps) => (
  <span
    className={cx(
      'inline-flex items-center p-2 whitespace-nowrap',
      {
        'rounded-full border text-xs leading-none tracking-normal normal-case -my-1 transform scale-90':
          isBadge,
        'bg-pageText border-transparent text-pageBG': primary,
        'bg-transparent border-pageText text-pageText': secondary,
        'px-3': !hasDot,
        'pr-3 before:inline-block before:mr-2 before:rounded-full before:w-[10px] before:h-[10px]':
          hasDot,
        'before:bg-pageBG': hasDot && primary,
        'before:bg-pageText': hasDot && secondary,
        'before:animate-shadow-pulse': hasDot && pulsingDot,
      },
      className,
    )}
  >
    {children}
  </span>
)

export default Label
